const $$splitComponentImporter = () => import('/Users/Javvad_1/Desktop/Petso_Dev/monorepo/petso-pro/src/routes/dashboard/org-chart.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import type { OrgChartLocation } from '@/api/holding-orgs';
export const Route = createFileRoute('/dashboard/org-chart')({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});

// ─── Holding Org Members Section ──────────────────────────────────────────